import { render, staticRenderFns } from "./noDdvertisement.vue?vue&type=template&id=52ca5f96&scoped=true"
import script from "./noDdvertisement.vue?vue&type=script&lang=js"
export * from "./noDdvertisement.vue?vue&type=script&lang=js"
import style0 from "./noDdvertisement.vue?vue&type=style&index=0&id=52ca5f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ca5f96",
  null
  
)

export default component.exports